export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/damaged.b293f256.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};